import { render } from "./PredictionGame.vue?vue&type=template&id=553ec25a"
import script from "./PredictionGame.vue?vue&type=script&lang=js"
export * from "./PredictionGame.vue?vue&type=script&lang=js"

import "./PredictionGame.vue?vue&type=style&index=0&id=553ec25a&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__